// extracted by mini-css-extract-plugin
module.exports = {"base":"static-layout_base__3-fAV","buttons":"static-layout_buttons__3nphU","content":"static-layout_content__1nrfy"};